import { Page } from '@/components/layout/page/page.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'

export const AccountingPageSkeleton = () => {
  return (
    <Page>
      <div className="flex items-center justify-between">
        <Skeleton className="h-[32px] w-[160px]" />
        <Skeleton className="h-[40px] w-[128px]" />
      </div>

      <div className="mt-5">
        <div className="grid grid-cols-2 gap-6">
          <Skeleton className="h-[320px]" />
          <Skeleton className="h-[320px]" />
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center justify-between">
          <Skeleton className="h-[28px] w-[160px]" />
          <Skeleton className="h-[40px] w-[128px]" />
        </div>
        <Skeleton className="mt-5 h-[320px] w-full" />
      </div>
    </Page>
  )
}
